import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { enTranslations } from "./translations/en";
import { esTranslations } from "./translations/es";
import { frTranslations } from "./translations/fr";
import { ptBrTranslations } from "./translations/pt-BR";

export const defaultNS = "translation" as const;

export const resources = {
  en: { translation: enTranslations },
  es: { translation: esTranslations },
  "pt-BR": { translation: ptBrTranslations },
  fr: { translation: frTranslations },
} as const;

export function isNonEnglishLanguage(language: string): boolean {
  return language !== "en";
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    defaultNS,
    fallbackLng: "en",
    resources,
    returnNull: false,
    detection: {
      order: ["localStorage", "sessionStorage", "navigator", "querystring", "cookie", "htmlTag", "path", "subdomain"],
    },
  });

export const t = i18n.t.bind(i18n);
export default i18n;
